class ClientService {

  auth(callback) {
    let bridgeHandler = function (bridge) {
      if (!!bridge) {
        //初始化
        if (!bridge._messageHandler) {
          callback(window.WebViewJavascriptBridge, null)
          bridge.init(function (message, responseCallback) {
            let data = {
              from: 'finger'
            };
            responseCallback(data);
          });
        }

        //获取App用户
        bridge.callHandler('getUserInfo', {}, function (data) {
          if (typeof data === 'string') {
            data = JSON.parse(data)
          }

          if (data.success && data.userInfo) {
            let userInfo = data.userInfo
            callback(window.WebViewJavascriptBridge, userInfo)
          } else {
            callback(window.WebViewJavascriptBridge, null)
          }
        });
      }
    }

    let bridge = window.WebViewJavascriptBridge

    if (!!bridge) {
      bridgeHandler(bridge)
      return
    }

    document.addEventListener('WebViewJavascriptBridgeReady', function (e) {
      bridge = window.WebViewJavascriptBridge
      bridgeHandler(bridge)
    }, false);

    //兼容iOS端WKWebView
    setupWebViewJavascriptBridge(function (bridge) {
      if (!!bridge) {
        //获取App用户
        bridge.callHandler('getUserInfo', {}, function (data) {
          if (typeof data === 'string') {
            data = JSON.parse(data)
          }

          if (data.success && data.userInfo) {
            let userInfo = data.userInfo
            callback(window.WebViewJavascriptBridge, userInfo)
          } else {
            callback(window.WebViewJavascriptBridge, null)
          }
        });
      }
    })

    function setupWebViewJavascriptBridge(callback) {
      if (window.WebViewJavascriptBridge) {
        return callback(WebViewJavascriptBridge);
      }
      if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
      }
      window.WVJBCallbacks = [callback];
      let WVJBIframe = document.createElement('iframe');
      WVJBIframe.style.display = 'none';
      WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe)
      }, 0)
    }
  }
}

export default new ClientService();
